import React from "react";
import styled from "styled-components";
import BWDisrupt from "../../images/BWDisrupt.png";
import ENTrackr from "../../images/ENTrackr.png";
import Entrepreneur from "../../images/Entrepreneur.png";
import inc42 from "../../images/inc42.webp";
import VCC from "../../images/VCC.png";
import YourStory from "../../images/YourStory.png";

const StyledWrapper = styled.section`
  background-color: var(--peach);
  padding: 3rem 0 4rem;
  @media (max-width: 768px) {
    margin-bottom: 0 !important;
    padding: 3rem 0 3rem;
  }

  img,
  svg {
    margin: 3rem 0;
    max-height: 50px;
    cursor: pointer;
    filter: grayscale(1);
    @media (max-width: 576px) and (min-width: 385px) {
      margin: 1.5rem 0;
      max-height: 24px;
    }
    @media (max-width: 385px) {
      max-height: 20px;
      margin: 1.5rem 0;
    }
  }

  .logoContainer {
    max-width: 1670px;
    margin: 0 auto 40px;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: nowrap;
    padding: 0 3rem;
    position: relative;
    &::after,
    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      display: block;
      width: 100%;
      height: 2px;
      background: linear-gradient(
        90deg,
        var(--peach) 0%,
        rgb(148, 151, 154) 50.38%,
        var(--peach) 100%
      );
    }
    &::before {
      top: 0;
    }
    &::after {
      bottom: 0;
    }
    & > * {
      flex: 0 auto;
      min-width: 0;
      min-height: 0;
      width: auto;
    }
    @media (max-width: 992px) {
      flex-wrap: wrap;
    }
    @media (max-width: 768px) {
      padding: unset;
      margin: 0 auto;
    }
  }
`;

const Featured = () => {
  const articles = [
    {
      img: YourStory,
      link: "https://yourstory.com/2021/10/funding-alert-fintech-startup-niro-seed-investment-elevar-equity/amp",
    },
    {
      img: VCC,
      link: "https://www.vccircle.com/fintech-startup-niro-raises-funds-from-elevar-equity-kunal-shah-others",
    },
    {
      img: BWDisrupt,
      link: "http://bwdisrupt.businessworld.in/article/Niro-Raises-3-5-Mn-Seed-Funding/13-10-2021-408543/",
    },
    {
      img: ENTrackr,
      link: "https://entrackr.com/2021/10/elevar-equity-leads-3-5-mn-seed-round-in-fintech-startup-niro/",
    },
    {
      img: Entrepreneur,
      link: "https://www.entrepreneur.com/article/390890",
    },
    {
      img: inc42,
      link: "https://inc42.com/buzz/embedded-finance-startup-niro-raises-a-3-5-mn-seed-round-from-founders-of-cred-uni-freo/amp/",
    },
  ];

  return (
    <StyledWrapper>
      <div className="container-fluid">
        <div className="row mb-5">
          <h5 className="text-center">As Featured In</h5>
        </div>
        <div className="row logoContainer">
          {articles.map((item, i) => (
            <a
              href={item.link}
              rel="noreferrer noopener"
              target="_blank"
              key={i}
            >
              <img src={item.img} alt="" className="img-fluid" />
            </a>
          ))}
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Featured;
